module.exports = __webpack_public_path__ + "img/Producer3.f47c6e20.png";